import * as React from 'react';
import _ from 'lodash';
import PanelFileExplorer from './Toolbox/PanelFileExplorer';

type Props = {
    tools: []
};
type ToolboxWrapperTypes = {
    children?: React.Node
};
const ToolboxWrapper = ({children}: ToolboxWrapperTypes) => (
    <div className="bg-gray-50 p-4  m-4 shadow w-1/1    rounded-lg   flex  justify-center   " rmthumb="1"
         style={{
             width: '250px'
             , height: '80vh'
             , overflowY: 'hidden'
             , overflowX: 'hidden'
         }}
    >{children}</div>
);
ToolboxWrapper.defaultProps = {
    children: null
};
export default function ToolboxFileExplorer({tools, minWidth, maxWidth, ShowLoaderFile, DeleteFile}: Props) {
    return (
        <ToolboxWrapper>
            <PanelFileExplorer
                key={_.identity('tool')}
                title={'Document Explorer'}
                collapse
                tools={tools}
                minWidth={minWidth}
                maxWidth={maxWidth}
                ShowLoaderFile={ShowLoaderFile}
                DeleteFile={e => DeleteFile(e)}
            />
        </ToolboxWrapper>
    );
}
